var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"bottom"}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),(_vm.logo !== 'debian')?_c('font-awesome-icon',{style:([_vm.$store.getters.darkMode ? { color: 'rgba(255, 255, 255, 0.65)' } : { color: '#666' }]),attrs:{"icon":['fab', _vm.logo],"size":_vm.size}}):(_vm.logo === 'debian')?_c('debian-icon',{style:({
      height: _vm.size === '4x' ? '56px' : '16px',
      width: _vm.size === '4x' ? '56px' : '16px',
      marginBottom: '-4px',
      background: _vm.$store.getters.darkMode ? 'rgba(255, 255, 255, 0.65)' : ''
    })}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }